import {
  init_utils
} from "./chunk-SBNKSDBP.mjs";
import {
  cn
} from "./chunk-CVRFJC2Q.mjs";

// src/components/button/Spinner.tsx
init_utils();
import React from "react";
var Spinner = ({ className }) => {
  return /* @__PURE__ */ React.createElement(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      stroke: "currentColor",
      fill: "none",
      viewBox: "0 0 66 66",
      className: cn("h-4 w-4 animate-spin text-inherit", className),
      "data-testid": "spinner"
    },
    /* @__PURE__ */ React.createElement(
      "circle",
      {
        cx: "33",
        cy: "33",
        fill: "none",
        r: "28",
        stroke: "currentColor",
        strokeWidth: "10",
        className: "opacity-30"
      }
    ),
    /* @__PURE__ */ React.createElement(
      "circle",
      {
        cx: "33",
        cy: "33",
        fill: "none",
        r: "28",
        stroke: "currentColor",
        strokeDasharray: "40, 134",
        strokeDashoffset: "325",
        strokeLinecap: "round",
        strokeWidth: "10",
        className: "opacity-70"
      }
    )
  );
};

export {
  Spinner
};
